<template>
<div>
    <header>
        <span v-if="userInfo">{{ userInfo.display_name }}</span>
        <span v-else>
            <Skeletor width="100" /></span>
        <div class="h-left">
            <a @click="redirectBack"><img src="~@/assets/images/icon02.svg" /></a>
        </div>
    </header>
    <div id="wrap" v-if="userInfo">
        <div class="prof-ph">
            <p class="fav"><i class="fas fa-heart"></i></p>
            <p class="prof-ph03">{{ userInfo.display_name }}</p>
            <p class="prof-ph04">
                <span style="white-space: pre;">{{ getLiving(userInfo.living_area_id) + " "}} {{userInfo.age}}歳 {{" " + getGender(userInfo.sex) }}</span>
                <i class="fas fa-heart red" style="margin-left: 7px;"></i> {{ userInfo.total_like }}いいね！
                <span v-if="parseInt(userInfo.sex) === FEMALE">
                    <i class="fas fa-phone pink"></i> 通話{{ getCallStatus(userInfo.enabled_call) }}
                    <span v-if="IS_WAITING_FOR_MEET === parseInt(userInfo.waiting_for_meet)" style="margin-left: 7px;"> <i class="fas fa-calendar-check pink2"></i> 本日OK </span>
                </span>
                <span v-if="parseInt(userInfo.sex) === MALE">
                    <i v-if="getFieldProfile('income', userInfo.income) != '未設定'" class="fas fa-coins yellow"></i> {{ getFieldProfile('income', userInfo.income) }}
                </span>
            </p>
            <div class="prof-bg"></div>
            <div v-for="(item, index) in getImage(userInfo.image)" :id="'main_avatar_' + index" :key="index">
                <img v-if="img_index === index" :src="getImageUrl(item.path)" @click="openAvatar()" />
            </div>
        </div>

        <div class="prof-title">ひとこと</div>
        <div class="txt-area">
            <p>{{ userInfo.mood_status }}</p>

            <ul class="prof-ph02 clearfix" id="ul_img">
                <li v-for="(item, index) in getImage(userInfo.image)" :key="index">
                    <span v-if="index == 0 ||
                        parseInt(item.view_status) === VIEW_STATUS_AVATAR_ALL || 
                        (userInfo.is_like === IS_LIKE && userInfo.is_like_back !== IS_LIKE_BACK && parseInt(item.view_status) === VIEW_STATUS_AVATAR_LIKE) ||
                        (userInfo.is_matching === IS_MATCHING && parseInt(item.view_status) === VIEW_STATUS_AVATAR_MATCHING)">
                        <img v-if="index == 0" :id="'img_' + index" :src="getImageUrl(item.path)" @click="showSubAvatar(index)" style="border: 2px solid salmon;box-sizing: border-box;"/>
                        <img v-else :id="'img_' + index" :src="getImageUrl(item.path)" @click="showSubAvatar(index)"/>
                    </span>
                    <span v-else>
                        <i class="fas fa-user-lock prof-lock"></i><img :src="getImageUrl(item.path)" class="blur" />
                    </span>
                </li>
            </ul>
        </div>

        <div class="prof-title">自己紹介</div>
        <div class="txt-area">
            <p v-html="userInfo.user_status">
            </p>
        </div>
    </div>
</div>

<imageShow :active="isShowImage">
    <div>
        <img :src="getPopupImage()" style="width: 100%;" id="popupImage">
    </div>
</imageShow>
</template>

<script>
import "vue-skeletor/dist/vue-skeletor.css";
import imageShow from "../../user/components/imageShow"
import {
    Skeletor
} from 'vue-skeletor';
import {
    mapGetters
} from "vuex";
import mixin from '@/mixin'
import CONSTANTS from '@/constants'
export default {
    name: "user detail",
    props: {
        idUser: {
            type: String,
            default: null
        }
    },
    emits: ['close'],
    components: {
        Skeletor,
        imageShow,
    },
    mixins: [mixin],
    data: () => ({
        userInfo: null,
        IS_WAITING_FOR_MEET: CONSTANTS.IS_WAITING_FOR_MEET,
        VIEW_STATUS_AVATAR_ALL: CONSTANTS.VIEW_STATUS_AVATAR_ALL,
        VIEW_STATUS_AVATAR_LIKE: CONSTANTS.VIEW_STATUS_AVATAR_LIKE,
        VIEW_STATUS_AVATAR_MATCHING: CONSTANTS.VIEW_STATUS_AVATAR_MATCHING,
        IS_LIKE: CONSTANTS.IS_LIKE,
        IS_LIKE_BACK: CONSTANTS.IS_LIKE_BACK,
        MALE: CONSTANTS.MALE,
        isShowImage: false,
        FEMALE: CONSTANTS.FEMALE,
        isShowPopup: false,
        img_index: 0,
    }),
    mounted() {
        this.getuserInfo()
    },
    computed: {
        ...mapGetters(["metadata", 'defaultToken', "userDetail"]),
        userId() {
            if (this.idUser) {
                return this.idUser
            }
            return this.$route.query.id
        },
    },
    methods: {
        redirectBack() {
            if (this.idUser) {
                this.$emit('close')
                return
            }
        },
        showSubAvatar(index) {
            this.img_index = index;
            let ul_img = document.getElementById('ul_img').getElementsByTagName('img');
            for (var i = 0; i < ul_img.length; i++) {
                ul_img[i].style = '';
            }

            document.getElementById('img_' + index).style = "border: 2px solid salmon;box-sizing: border-box;";
        },
        getPopupImage() {
            if (this.img_index == 0) {
                return this.getImageUrl(this.userInfo.avatar_url);
            } else {
                return this.getImageUrl(document.getElementById('main_avatar_' + this.img_index).getElementsByTagName('img')[0].src);
            }
        },
        openAvatar() {
            this.isShowImage = true
            document.addEventListener("click", (evt) => {
                const flyoutElement = document.getElementById("popupImage");
                let targetElement = evt.target; // clicked element
                do {
                    if (targetElement == flyoutElement) {

                        return;
                    }
                    // Go up the DOM
                    targetElement = targetElement.parentNode;
                    // targetElement.getElementsByTagName('img')[0].src = document.getElementById('main_avatar').getElementsByTagName('img')[0].src;
                } while (targetElement);
                const wrap = document.querySelector(".wrap");
                if (wrap == evt.target) {
                    this.isShowImage = false
                }
                // This is a click outside.

            });
        },
        getImage(images) {
            if (images) {
                let imgs = JSON.parse(images)
                if (imgs[0]) {
                    imgs = imgs.filter(item => {
                        return item.is_approve === 0 && !item.path.includes(CONSTANTS.URL_DEFAULT)
                    })
                }
                return imgs
            }
        },
        async getuserInfo() {
            this.$store.dispatch("route/showLoading")
            await this.$store.dispatch('user/userShow', {
                id: this.userId,
                token: this.defaultToken
            }).then(data => {
                this.userInfo = data
            }).catch(err => {
                console.log(err)
            })
            this.$store.dispatch("route/hideLoading")
        },
        getLiving(id) {
            if (!this.metadata) return null
            let living = this.metadata.user_profile_list.living_area.filter(
                (item) => {
                    return item.field_id === id;
                }
            );
            if (living[0]) {
                return living[0].name;
            }
            return null;
        },

        getFieldProfile(field, id) {
            if (!this.metadata) return null
            let filedData = this.metadata.user_profile_list[field].filter((item) => {
                return parseInt(item.value) === parseInt(id);
            });
            if (filedData[0]) {
                return filedData[0].name;
            }
            return CONSTANTS.NOT_VALUE;
        },

    }
}
</script>

<style scoped>
.iine-btn2 {
    font-size: 12px;
}

.flex-row {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.flex-row button {
    outline: none;
    border: none;
    color: #4a87fb;
    width: 100%;
    background: #fff;
    padding: 10px;
}

.flex-row button.btn-start {
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
}

.flex-row button.btn-end {
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
}

.flex-row button.btn-close {
    margin-top: 15px;
    border-radius: 5px;
}
</style>
